<template>
  <div>
    <b-row>
      <b-col
        md="2"
        sm="4"
        class="my-1"
      >
        <b-form-group
          class="mb-0"
        >
          <label class="d-inline-block text-sm-left mr-50">Anzeigen pro Seite</label>
          <b-form-select
            id="perPageSelect"
            v-model="perPage"
            size="sm"
            :options="pageOptions"
            class="w-50"
          />
        </b-form-group>
      </b-col>

      <b-col
          md="2"
          sm="4"
          class="my-1"
      >
      </b-col>
      <b-col
        md="2"
        sm="4"
        class="my-1"
      />

      <b-col
        md="6"
        class="my-1"
      >
        <b-form-group
          label="Filter"
          label-cols-sm="3"
          label-align-sm="right"
          label-size="sm"
          label-for="filterInput"
          class="mb-0"
        >
          <b-input-group size="sm">
            <b-form-input
              id="filterInput"
              v-model="filter"
              type="search"
              placeholder="z.b. Name"
            />
            <b-input-group-append>
              <b-button
                :disabled="!filter"
                @click="filter = ''"
              >
                Leeren
              </b-button>
            </b-input-group-append>
            <b-button
              size="sm"
              class="ml-2 btn-success"
              @click="New"
            >
              Neuer Kunde
            </b-button>
          </b-input-group>
        </b-form-group>

      </b-col>

      <b-col cols="12">
        <b-table
          striped
          hover
          responsive
          :per-page="perPage"
          :items="items"
          :fields="fields"
          @row-clicked="Click"
        >
          <template #cell(SevDeskId)="data">
            <img
                :src="sevDeskLogo"
                alt="Logo"
                width="32"
                :style="{ filter: (data.item.SevDeskId != null && data.item.SevDeskId !== '') ? 'grayscale(0)' : 'grayscale(1)' }"
                @click="data.item.SevDeskId ? null :  CreateSevdeskContact(data.item.CustomerNumber) "
                v-b-tooltip.hover.v-primary
                variant="outline-primary"
                :title="  (data.item.SevDeskId != null && data.item.SevDeskId !== '') ? ( 'Id: ' + data.item.SevDeskId) : 'Klicken zum erstellen'"

            />

          </template>
          <template #cell(CustomerType)="data">
            <b-badge class="float-right" variant="secondary" v-show="data.item.CustomerType == 0">Keine Zuordnung</b-badge>
            <b-badge class="float-right" variant="info" v-show="data.item.CustomerType == 1">Crew</b-badge>
            <b-badge class="float-right" variant="success" v-show="data.item.CustomerType == 2">Reisebüro</b-badge>
          </template>
        </b-table>
      </b-col>

      <b-col
        cols="12"
      >
        <b-pagination
          v-model="currentPage"
          :total-rows="totalRows"
          :per-page="perPage"
          align="center"
          size="sm"
          class="my-0"
        />
      </b-col>
    </b-row>
  </div>

</template>

<script>
import {
  BTable, BAvatar, BBadge, BRow, BCol, BFormGroup, BFormSelect, BPagination, BInputGroup, BFormInput, BInputGroupAppend, BButton, VBTooltip, BFormCheckbox
} from 'bootstrap-vue'
import ToastificationContent from '@core/components/toastification/ToastificationContent'

import Ripple from 'vue-ripple-directive'
export default {
  components: {
    BTable,
    BAvatar,
    BBadge,
    BRow,
    BCol,
    BFormGroup,
    BFormSelect,
    BPagination,
    BInputGroup,
    BFormInput,
    BInputGroupAppend,
    BButton,
    BFormCheckbox
  },
  directives: {
    'b-tooltip': VBTooltip,
    Ripple,
  },
  data() {
    return {

      sevDeskLogo: require('@/assets/images/logo/sevdesk-logo.png'),
      lastClickedRow: -1,
      perPage: 25,
      pageOptions: [10, 25, 50, 100],
      totalRows: 1,
      currentPage: 1,
      filter: null,
      filterTimeout: null,
      fields: [
        {
          key: 'CustomerNumber',
          label: 'ID',
        },
        {
          key: 'Name',
          label: 'Name',
        },
        {
          key: 'Contact.Phone',
          label: 'Telefon',
        },
        {
          key: 'Contact.Email',
          label: 'E-Mail',
        },
        {
          key: 'Address.Fomarted',
          label: 'Adresse',
        },
        {
          key: 'SevDeskId',
          label: 'SevDesk',
        },
        {
          key: 'CustomerType',
          label: 'Typ',
        },
      ],
      items: [],
    }
  },
  computed: {
    sortOptions() {
      // Create an options list from our fields
      return this.fields
        .filter(f => f.sortable)
        .map(f => ({
          text: f.label,
          value: f.key,
        }))
    },
  },
  mounted() {
    this.$nextTick(() => {
      document.title = 'Kunden'
    })
    this.LoadList()
    // Set the initial number of items
    this.totalRows = this.items.length
    this.$watch(
      () => this.currentPage,
      val => {
        this.LoadList()
      },
    )

    this.$watch(
        () => this.perPage,
        val => {
          const v = this
          if (this.filterTimeout) clearTimeout(this.filterTimeout)
          this.filterTimeout = setTimeout(() => {
            v.LoadList()
          }, 550)
        },
    )
    this.$watch(
      () => this.filter,
      val => {
        const v = this
        if (this.filterTimeout) clearTimeout(this.filterTimeout)
        this.filterTimeout = setTimeout(() => {
          v.LoadList()
        }, 550)
      },
    )
  },
  methods: {
    Reset() {
    },
    New() {
      this.$router.push({ name: 'customer', params: { id: 0 }})

    },
    Click(record, index) {
      if (event.target.tagName.toLowerCase() !== 'img') {
        this.$router.push({ name: 'customer', params: { id: record.IdentId }})
      }

    },
    Save() {

    },
    CreateSevdeskContact(customerNumber) {
      this.$swal({
        title: 'SevDesk Kontakt',
        text: 'Möchten Sie wirklich einen SevDesk Kontakt erstellen?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Ja!',
        cancelButtonText: 'Nein, abbrechen',
        customClass: {
          confirmButton: 'btn btn-primary',
          cancelButton: 'btn btn-outline-danger ml-1',
        },
        buttonsStyling: false,
      })
          .then(result => {
            if (result.isConfirmed) {
              this.$http.post('/customer/sevdesk/add/' + customerNumber, JSON.stringify("[]"))
                  .then(resp => {
                    if (resp.data.success) {
                      this.$toast({
                        component: ToastificationContent,
                        props: {
                          title: 'Info',
                          icon: 'CheckIcon',
                          text: 'Zugewiesene SevDeskId: ' + resp.data.sevdeskId,
                          variant: 'success',
                        },
                      })
                    }
                  })
                  .catch(err => {
                    console.error(err)
                  })
            }
          })
    },
    LoadList() {

      this.items = []
      const c1 = (this.currentPage - 1) * this.perPage
      let url = `/customer/list?from=${c1}&count=${this.perPage}`
      if (this.filter && this.filter !== '') {
        url = `/customer/list/filter?filter=${this.filter}`
      }
      this.$http.get(url)
        .then(resp => {
          this.totalRows = resp.data.info.fullEntries
          resp.data.list.forEach(i => {
            i.Address.Fomarted = `${i.Address.Street}, ${i.Address.ZipCode} ${i.Address.Location}`
            this.items.push(i)
          })
        })
        .catch(err => {
          console.error(err)
        })
    },
  },
}
</script>
